import API from "..";

export const getSenderIDLists = async () => {
  const response = await API.get(
    `/campaign/sms/sender-id/list?page=1&limit=15`
  );

  return response.data.data;
};

export const createSenderID = async (data: { name: string }) => {
  const response = await API.post(`/campaign/sms/sender-id/create`, data);

  return response.data;
};
export const deleteSenderID = async (data: { senderUid: string }) => {
  const response = await API.delete(`/campaign/sms/sender-id/delete/${data.senderUid}`);

  return response.data;
};
export const createEmailSenderID = async (data: { name: string, email:string }) => {
  const response = await API.post(`/campaign/email/sender/create`, data);

  return response.data;
};
export const initiateEmailSenderVerification = async (data: { email_sender_uid:string }) => {
  const response = await API.post(`/campaign/email/sender/send-otp`, {
    email_sender_uid: data.email_sender_uid,
  });

  return response.data;
};
export const confirmEmailSenderVerification = async (data: { emailSenderUid:string, code:string | number }) => {
  const response = await API.post(`/campaign/email/sender/verify-otp`, {
    email_sender_uid: data.emailSenderUid,
    code: data.code,
  });

  return response.data;
};
export const editEmailSenderID = async (data: { email_sender_name: string, email_sender_uid:string }) => {
  const response = await API.put(`/campaign/email/sender/edit`, data);

  return response.data;
};
export const deleteEmailSenderID = async (data: { senderUid: string }) => {
  const response = await API.delete(`/campaign/email/sender/delete/${data.senderUid}`);

  return response.data;
};
export const getEmailSenderIDLists = async () => {
  const response = await API.get(
    `/campaign/email/sender/list`
  );

  return response.data.data;
};
